import Select, { GroupBase, Props, Props as SelectProps } from "react-select";
import { cn } from "../utils/misc";

export default function ReactSelect<
    Option,
    IsMulti extends boolean = false,
    Group extends GroupBase<Option> = GroupBase<Option>
>(props: Props<Option, IsMulti, Group>) {
    return (
        <Select<Option, IsMulti, Group>
            {...props}
            className={cn("react-select-container text-sm", props.className)}
            classNamePrefix="react-select"
        />
    );
}
